var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "46px",
    viewBox: "0 0 27 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "seta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interna_01-copy",
    transform: "translate(-1517.000000, -861.000000)",
    fill: "#D3D0CB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seta",
    transform: "translate(1530.000000, 884.000000) scale(-1, 1) translate(-1530.000000, -884.000000) translate(1515.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(14.618376, 14.781623) rotate(-45.000000) translate(-14.618376, -14.781623) ",
    x: -2.18162325,
    y: 11.1816227,
    width: 33.599998,
    height: 7.19999957,
    rx: 3.59999979
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    transform: "translate(14.618376, 33.444976) scale(1, -1) rotate(-45.000000) translate(-14.618376, -33.444976) ",
    x: -2.18162325,
    y: 29.8449766,
    width: 33.599998,
    height: 7.19999957,
    rx: 3.59999979
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.45555f3ba1ca75be9c093ea0fadec32e.svg";
export { ForwardRef as ReactComponent };